'use client';

// Error boundaries must be Client Components
import { reportError } from '@lib/utils/reportError';
import { useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@src/components/ui/card';
import { Button } from '@src/components/ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';
export default function GlobalError({
  error,
  reset
}: {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(error);
  }, [error]);
  return (
    // global-error must include html and body tags
    <html data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
      <body className="bg-background text-foreground">
        <div className="flex min-h-screen items-center justify-center p-4">
          <Card className="w-full max-w-md" data-sentry-element="Card" data-sentry-source-file="global-error.tsx">
            <CardHeader className="text-center" data-sentry-element="CardHeader" data-sentry-source-file="global-error.tsx">
              <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-destructive/10">
                <AlertTriangle className="size-6 text-destructive" data-sentry-element="AlertTriangle" data-sentry-source-file="global-error.tsx" />
              </div>
              <CardTitle className="text-xl" data-sentry-element="CardTitle" data-sentry-source-file="global-error.tsx">Something went wrong!</CardTitle>
              <CardDescription data-sentry-element="CardDescription" data-sentry-source-file="global-error.tsx">
                An error occurred that prevented the application from loading. This has been reported automatically.
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center" data-sentry-element="CardContent" data-sentry-source-file="global-error.tsx">
              <Button onClick={() => {
                reset();
              }} className="w-full" data-sentry-element="Button" data-sentry-source-file="global-error.tsx">
                <RefreshCw className="mr-2 size-4" data-sentry-element="RefreshCw" data-sentry-source-file="global-error.tsx" />
                Try again
              </Button>
            </CardContent>
          </Card>
        </div>
      </body>
    </html>
  );
}